import { CalendarAppointment } from "../../../../@client/Theasoft_ApiServer_Calendar"
import { timeOnlyToDayjs } from "../../../../utils/time-only-to-dayjs"

export const MIDDLE_OF_DAY = 14

export function SegmentCalendarAppointmentsToHalfDays(
  appointments: CalendarAppointment[]
) {
  const firstHalfOfDay = new Set<CalendarAppointment>()
  const secondHalfOfDay = new Set<CalendarAppointment>()

  appointments?.forEach((appointment) => {
    if (
      appointment.start &&
      timeOnlyToDayjs(appointment.start).hour() < MIDDLE_OF_DAY
    ) {
      firstHalfOfDay.add(appointment)
    } else if (appointment.start) {
      secondHalfOfDay.add(appointment)
    }

    if (
      appointment.end &&
      timeOnlyToDayjs(appointment.end).hour() <= MIDDLE_OF_DAY
    ) {
      firstHalfOfDay.add(appointment)
    } else if (appointment.end) {
      secondHalfOfDay.add(appointment)
      if (!appointment.start) {
        firstHalfOfDay.add(appointment)
      }
    }

    if (!appointment.start && !appointment.end) {
      firstHalfOfDay.add(appointment)
      secondHalfOfDay.add(appointment)
    }
  })

  return {
    firstHalfOfDay: Array.from(firstHalfOfDay),
    secondHalfOfDay: Array.from(secondHalfOfDay),
    MIDDLE_OF_DAY,
  }
}
